
import { Trophy, Award } from "lucide-react";
import { NavItemProps } from "./NavItems";
import React from "react";

export const getNavLinks = (): NavItemProps[] => [
  { 
    name: "Services", 
    path: "#",
    dropdown: true,
    items: [
      { 
        name: "Local SEO", 
        path: "/services/local-seo", 
        description: "Boost your local business visibility in search results"
      },
      { 
        name: "Competitive Keywords", 
        path: "/services/competitive-keywords",
        description: "Target high-value keywords to outrank your competition"
      },
      { 
        name: "E-commerce SEO", 
        path: "/services/ecommerce-seo",
        description: "Optimize your online store for better conversions" 
      },
      {
        name: "Law Firm SEO",
        path: "https://www.lawseofirm.com",
        description: "Specialized SEO strategies for law firms and legal practices",
        external: true
      },
      { 
        name: "Specialized Industries", 
        path: "/services/specialized-industries",
        description: "Tailored strategies for niche markets and industries" 
      },
      { 
        name: "Enterprise Solutions", 
        path: "/services/enterprise-seo",
        description: "Comprehensive SEO strategies for large organizations" 
      },
    ]
  },
  { name: "Case Studies", path: "/case-studies" },
  { name: "Pricing", path: "/pricing" },
  { 
    name: "SEO Quiz", 
    path: "#",
    dropdown: true,
    items: [
      { 
        name: "Basic SEO Quiz", 
        path: "/seo-quiz", 
        description: "Test your fundamental SEO knowledge with 10 questions",
        icon: React.createElement(Trophy, { className: "w-4 h-4 mr-1" })
      },
      { 
        name: "Advanced Assessment", 
        path: "/seo-assessment-test",
        description: "Challenge yourself with 25 difficult SEO questions",
        icon: React.createElement(Award, { className: "w-4 h-4 mr-1" })
      },
    ]
  },
  { name: "Contact", path: "/contact" },
];
